import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import UserMeInfo from '../models/account/UserMeInfo';
import GenericBaseResponseDTO from '../models/validation/GenericBaseResponseDTO';
import EmulationDTO from '../models/account/EmulationDTO';
import LoginDTO from '../models/account/LoginDTO';
import RegisterDTO from '../models/account/RegisterDTO';
import ForgotPasswordDTO from '../models/account/ForgotPasswordDTO';
import ResetPasswordDTO from '../models/account/ResetPasswordDTO';

export class AccountApiController {
    // post: Account/Login
    public RouteLogin = () => `Account/Login`;
    public login(request: LoginDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<GenericBaseResponseDTO<UserMeInfo>>> {
        let url = this.RouteLogin();
        return HttpApi.RestRequest<any, GenericBaseResponseDTO<UserMeInfo>>(request, 'post', url, requestOptions);
    }
    // post: Account/Register
    public RouteRegister = () => `Account/Register`;
    public register(request: RegisterDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<GenericBaseResponseDTO<UserMeInfo>>> {
        let url = this.RouteRegister();
        return HttpApi.RestRequest<any, GenericBaseResponseDTO<UserMeInfo>>(request, 'post', url, requestOptions);
    }
    // get: Account/KeepAlive
    public RouteKeepAlive = () => `Account/KeepAlive`;
    public keepAlive(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<string>> {
        let url = this.RouteKeepAlive();
        return HttpApi.RestRequest<any, string>(null, 'get', url, requestOptions);
    }
    // get: Account/Me
    public RouteMe = () => `Account/Me`;
    public me(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<GenericBaseResponseDTO<UserMeInfo>>> {
        let url = this.RouteMe();
        return HttpApi.RestRequest<any, GenericBaseResponseDTO<UserMeInfo>>(null, 'get', url, requestOptions);
    }
    // post: Account/Logout
    public RouteLogout = () => `Account/Logout`;
    public logout(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteLogout();
        return HttpApi.RestRequest<any, void>(null, 'post', url, requestOptions);
    }
    // get: Account/GetCurrentEmulationInfo
    public RouteGetCurrentEmulationInfo = () => `Account/GetCurrentEmulationInfo`;
    public getCurrentEmulationInfo(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<EmulationDTO>> {
        let url = this.RouteGetCurrentEmulationInfo();
        return HttpApi.RestRequest<any, EmulationDTO>(null, 'get', url, requestOptions);
    }
    // post: Account/StopEmulation
    public RouteStopEmulation = () => `Account/StopEmulation`;
    public stopEmulation(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteStopEmulation();
        return HttpApi.RestRequest<any, void>(null, 'post', url, requestOptions);
    }
    // post: Account/Emulate?locationId=${locationId}&emulationType=${encodeURIComponent(emulationType)}
    public RouteEmulate = (locationId: number, emulationType: string) => `Account/Emulate?locationId=${locationId}&emulationType=${encodeURIComponent(emulationType)}`;
    public emulate(locationId: number, emulationType: string, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<GenericBaseResponseDTO<UserMeInfo>>> {
        let url = this.RouteEmulate(locationId, emulationType);
        return HttpApi.RestRequest<any, GenericBaseResponseDTO<UserMeInfo>>(null, 'post', url, requestOptions);
    }
    // post: Account/EmulateState?stateId=${stateId}
    public RouteEmulateState = (stateId: number) => `Account/EmulateState?stateId=${stateId}`;
    public emulateState(stateId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteEmulateState(stateId);
        return HttpApi.RestRequest<any, void>(null, 'post', url, requestOptions);
    }
    // post: Account/EmulateDistrict?districtId=${districtId}
    public RouteEmulateDistrict = (districtId: number) => `Account/EmulateDistrict?districtId=${districtId}`;
    public emulateDistrict(districtId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteEmulateDistrict(districtId);
        return HttpApi.RestRequest<any, void>(null, 'post', url, requestOptions);
    }
    // post: Account/EmulateSchool?schoolId=${schoolId}
    public RouteEmulateSchool = (schoolId: number) => `Account/EmulateSchool?schoolId=${schoolId}`;
    public emulateSchool(schoolId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteEmulateSchool(schoolId);
        return HttpApi.RestRequest<any, void>(null, 'post', url, requestOptions);
    }
    // post: Account/SendForgotPasswordEmail
    public RouteSendForgotPasswordEmail = () => `Account/SendForgotPasswordEmail`;
    public sendForgotPasswordEmail(forgotPassword: ForgotPasswordDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteSendForgotPasswordEmail();
        return HttpApi.RestRequest<any, void>(forgotPassword, 'post', url, requestOptions);
    }
    // post: Account/ResetPassword
    public RouteSelfServePasswordReset = () => `Account/ResetPassword`;
    public selfServePasswordReset(resetPassword: ResetPasswordDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteSelfServePasswordReset();
        return HttpApi.RestRequest<any, void>(resetPassword, 'post', url, requestOptions);
    }
    // post: Account/UpdateSelectedCulture
    public RouteUpdateSelectedCulture = (cultureId: number) => `Account/UpdateSelectedCulture`;
    public updateSelectedCulture(cultureId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteUpdateSelectedCulture(cultureId);
        return HttpApi.RestRequest<any, void>(cultureId, 'post', url, requestOptions);
    }
}
var service = new AccountApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/AccountApiController.ts